import React, { useEffect } from 'react';
import Backdrop from './Backdrop/Backdrop';
import Burger from './Burger/Burger';
import Logo from '../Icons/Logo';
import Menu from './Menu/Menu';
import Button from '../ui/Button/Button';
import LanguageSelector from './LanguageSelector/LanguageSelector';
import useToggle from '../../../hooks/useToggle';
import cn from 'classnames';
import useKeyboardNavigation from '../../../hooks/useKeyboardNavigation';
import useWindowSize from '../../../hooks/useWindowSize';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTE_NAMES } from '../../../contstants/route';
import styles from './Header.module.scss';

/**
 * Header component with navigation menu and logo
 */
const Header = (data) => {
  const { isOpen, toggle } = useToggle();
  const navigate = useNavigate();
  const { isMobile } = useWindowSize();
  const location = useLocation();
  const isJaecoo5Page = location.pathname === '/jaecoo-5';

  useKeyboardNavigation({
    isOpen,
    toggle,
  });

  useEffect(() => {
    if (isOpen && isMobile) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isOpen, isMobile]);
  return (
    <>
      <header className={cn(styles.header, isOpen && styles.header_filter)}>
        <div className="container">
          <div className={styles.header_inner}>
            <div className={cn(styles.header_inner_item, styles.customBurger)}>
              <Burger isOpen={isOpen} onClick={toggle} />
            </div>
            <div
              className={cn(styles.header_inner_item, styles.customLogo)}
              onClick={isOpen ? toggle : () => {}}
            >
              <a href={data?.fields?.logoUrl?.value?.href || '/'}>
                <Logo color="#000" />
              </a>
            </div>
            <div className={cn(styles.header_inner_item, styles.customButtons)}>
              {isJaecoo5Page ? (
                <Button isShowTooltip={true} variant={'secondary'} className={styles.comingSoon}>
                  {data?.fields?.BrochureBtnName?.value}
                </Button>
              ) : (
                <a
                  href={
                    `${data?.fields?.Brochure?.value?.href || ''}${
                      data?.fields?.Brochure?.value?.querystring || ''
                    }` || '/download-center'
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <button
                    className={cn(
                      styles.header_inner_item_button,
                      styles.header_inner_item_button_first
                    )}
                  >
                    {data?.fields?.BrochureBtnName?.value}
                  </button>
                </a>
              )}
              <button
                className={cn(
                  styles.header_inner_item_button,
                  styles.header_inner_item_button_first
                )}
                onClick={() => {
                  const href =
                    `${data?.fields?.Enquiry?.value?.href || ''}${
                      data?.fields?.Enquiry?.value?.querystring || ''
                    }` || '/contact-us';
                  navigate(href);
                }}
              >
                {data?.fields?.EnquiryBtnName?.value}
              </button>

              <a
                href={
                  `${data?.fields?.['Find Dealer']?.value?.href || ''}${
                    data?.fields?.['Find Dealer']?.value?.querystring || ''
                  }` || ROUTE_NAMES.findADealer
                }
              >
                <button
                  className={cn(
                    styles.header_inner_item_button,
                    styles.header_inner_item_button_second
                  )}
                  type="button"
                >
                  {data?.fields?.FindAealerBtnName?.value}
                </button>
              </a>
              <LanguageSelector
                languageList={data?.fields?.languageList}
                currentLanguage={data?.fields?.currentLanguage}
              />
            </div>
            <Menu
              menuInfo={data.fields.Menu}
              languageList={data?.fields?.languageList}
              isOpen={isOpen}
              onClick={toggle}
            />
          </div>
        </div>
      </header>
      <Backdrop isOpen={isOpen} onClick={toggle} />
    </>
  );
};

export default Header;
